import { render, staticRenderFns } from "./BnDevis.vue?vue&type=template&id=d8d0045e&"
import script from "./BnDevis.vue?vue&type=script&lang=js&"
export * from "./BnDevis.vue?vue&type=script&lang=js&"
import style0 from "./BnDevis.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports